/**
 * 本地访客 ID 公共模块 
 * 在 ug-common.js 加载完成后调用；首次调用生成，之后复用 localStorage 中的值。
 * 存储键：ug_user_id。若线上已有存储键，请沿用原键名，避免更换已有访客 ID。
 * 不设置过期时间；清除网站数据或更换浏览器/站点后可能生成新 ID。
 * 浏览器禁止本地存储时会抛错，调用方需在 try/catch 中处理。
 * Ptengine 示例（SDK 就绪后调用）：
 *   try {
 *     const visitorId = window.ugreenUtils.visitorId.getOrCreate();
 *     window.ptengine.identify(visitorId, {});
 *     window.ptengine.track('email_signup_success', { ug_user_id: visitorId });
 *   } catch (error) {
 *     console.warn('用户 ID 获取或上报失败', error);
 *   }
 */
(function () {
  window.ugreenUtils = window.ugreenUtils || {};
  if (window.ugreenUtils.visitorId) return;
  const STORAGE_KEY = 'ug_user_id'; // 已有用户 ID 时，必须沿用原存储键

  // md5 加密
  function md5(text) {
    const bytes = new TextEncoder().encode(text);
    const buffer = new ArrayBuffer(Math.ceil((bytes.length + 9) / 64) * 64);
    const view = new DataView(buffer);
    new Uint8Array(buffer).set(bytes);
    view.setUint8(bytes.length, 0x80);
    view.setUint32(buffer.byteLength - 8, bytes.length * 8, true);
    const shifts = [7, 12, 17, 22, 5, 9, 14, 20, 4, 11, 16, 23, 6, 10, 15, 21];
    const state = [0x67452301, 0xefcdab89, 0x98badcfe, 0x10325476];

    for (let offset = 0; offset < buffer.byteLength; offset += 64) {
      let [a, b, c, d] = state;
      for (let i = 0; i < 64; i++) {
        const round = Math.floor(i / 16);
        let f, g;
        if (round === 0) { f = (b & c) | (~b & d); g = i; }
        else if (round === 1) { f = (d & b) | (~d & c); g = (5 * i + 1) % 16; }
        else if (round === 2) { f = b ^ c ^ d; g = (3 * i + 5) % 16; }
        else { f = c ^ (b | ~d); g = (7 * i) % 16; }
        const k = Math.floor(Math.abs(Math.sin(i + 1)) * 0x100000000);
        const sum = (a + f + k + view.getUint32(offset + g * 4, true)) | 0;
        const shift = shifts[round * 4 + i % 4];
        const next = (b + ((sum << shift) | (sum >>> (32 - shift)))) | 0;
        a = d; d = c; c = b; b = next;
      }
      [a, b, c, d].forEach((value, i) => { state[i] = (state[i] + value) | 0; });
    }
    return state.map(value => [0, 8, 16, 24].map(shift =>
      ((value >>> shift) & 255).toString(16).padStart(2, '0')
    ).join('')).join('');
  }

  // 有值就复用；没有才生成。不设置过期时间。
  function getOrCreate() {
    let visitorId = window.localStorage.getItem(STORAGE_KEY);
    if (!visitorId) {
      const random = Math.random().toString(36).slice(2);
      const rawId = `${Date.now()}ug${random}`;
      visitorId = md5(rawId);
      window.localStorage.setItem(STORAGE_KEY, visitorId);
    }
    return visitorId;
  }

  window.ugreenUtils.visitorId = Object.freeze({ getOrCreate });
})();

document.addEventListener('DOMContentLoaded',()=>{
  document.addEventListener('click',(e)=>{
    let event = e || window.event;
    let target = event.target || event.srcElement;
    // 语言下拉
    if(target.classList.value.indexOf('ug-change-countrylanFn')!=-1){
      if(target.nextElementSibling){
        if(target.nextElementSibling.classList.value.indexOf('dpn')!=-1){
          // 移动端 父级的transform 影响到 国家选择的定位  所以是移动端需要额外处理
          if(target.closest('#menu-drawer')){
            let drawer = target.closest('#menu-drawer');
            drawer.style.overflowY = 'hidden';
            target.nextElementSibling.style.transform = `translateY(${drawer.scrollTop}px)`;
          }
          target.nextElementSibling.classList.remove('dpn');
        }else{
          target.nextElementSibling.classList.add('dpn');
        }
      }
    }else{
      let countrydivList = document.querySelectorAll('.ug-change-countrylanFn-div');
      countrydivList = Array.from(countrydivList);
      countrydivList.forEach((item,k)=>{
        if(item.classList.value.indexOf('dpn')==-1){
          item.classList.add('dpn');
        }
      });
    }

    // // 语言点击
    // if(target.classList.value.indexOf('ug-change-countrylan-item')!=-1){
    //   if(document.querySelector('#Details-menu-drawer-container') && document.querySelector('#Details-menu-drawer-container').classList.value.indexOf('menu-opening')!=-1 ){
    //     if(document.querySelector('.header__icon--menu')){
    //       document.querySelector('.header__icon--menu').click();
    //     } 
    //   }
      
    //   let marketHandle = target.getAttribute('data-marketHandle');
    //   if(marketHandle != window.UgreenInfo.ugmarketHandle ){
    //     let return_to = '';
    //     let country_code = '';
    //     if(marketHandle == 'de'){
    //       return_to = '/de';
    //       country_code = 'DE';
    //     }else{
    //       return_to = '/';
    //       country_code = 'US';
    //     }
    //     fetchLoctionFn(return_to,country_code);
    //   }
      
    // }
    // 语言点击
    // if (target.classList.value.indexOf("ug-change-countrylan-item") != -1) {
    //   if (
    //     document.querySelector("#Details-menu-drawer-container") &&
    //     document
    //       .querySelector("#Details-menu-drawer-container")
    //       .classList.value.indexOf("menu-opening") != -1
    //   ) {
    //     if (document.querySelector(".header__icon--menu")) {
    //       document.querySelector(".header__icon--menu").click();
    //     }
    //   }

    //   let marketHandle = target.getAttribute("data-marketHandle");
    //   if (marketHandle != window.UgreenInfo.ugmarketHandle || marketHandle != 'us') {
    //     let return_to = "";
    //     let country_code = "";
    //     // Get current path and search params
    //     const currentPath = window.location.pathname;
    //     const searchParams = window.location.search;

    //     // Get current domain and check if we're already on the correct site
    //     const currentDomain = window.location.hostname;

    //     if (marketHandle != "us") {
    //       // Only switch to English site if we're currently on German site
    //       window.location.href =
    //         "https://nas-de.ugreen.com" + currentPath + searchParams;
    //       return;
    //     }
    //   }
    // }

  });

  function fetchLoctionFn(return_to,country_code){
    let url = '/localization';
    let senddata = new FormData();
    senddata.set('form_type','localization');
    senddata.set('utf8','✓');
    senddata.set('_method','put');
    senddata.set('return_to',return_to);
    senddata.set('country_code',country_code);
    fetch(url,{
      method: 'POST',
      body:senddata
    })
    .then((response) => response.json())
    .then((data)=>{
      window.location.href = return_to
    })
    .catch((error)=>{
      window.location.href = return_to
    });


  }
  // 跳转 3c nas 统一添加 ip 跳转忽略
    // 监听全局所有的 a 标签
    // document.querySelectorAll('a').forEach(function (anchor) {
    //   anchor.addEventListener('click', function (event) {
    //       // 获取当前的 href
    //       let href = this.getAttribute('href');
    //       // 检查 href 中是否包含 from=nas
    //       if (href && (href.includes('?from=nas') || href.includes('&from=nas'))) {
    //           // 如果 from=nas 存在，检查是否已经有参数 SkipCozyRedirect=yes，如果没有则添加
    //           if (!href.includes('SkipCozyRedirect=yes')) {
    //               // 判断 href 中是否已有其他参数
    //               if (href.includes('?')) {
    //                   // 已经有参数的情况下，增加 &a=xxx
    //                   href += '&SkipCozyRedirect=yes';
    //               } else {
    //                   // 没有其他参数，直接加 ?a=xxx
    //                   href += '?SkipCozyRedirect=yes';
    //               }
    //           }

    //           // 阻止默认跳转
    //           event.preventDefault();
              
    //           // 手动跳转到新构造的 href
    //           window.open(href,"_blank"); 
    //           // window.location.href = href;
    //       }
    //   });
    // });
  // 跳转 3c nas 统一添加 ip 跳转忽略 end

  // 所有出站链接都需要添加 rel=nofollow 属性
  function otherLinkAddNoFollow(){
    document.querySelectorAll('a').forEach(function(link) {
      const href = link.getAttribute('href');
      if (href && href.includes('//') && !href.includes(window.location.hostname)) {
        // 如果是外部链接，添加 rel="nofollow" 属性
        link.setAttribute('rel', 'nofollow');
      }
    });
  }
  setTimeout(() => {
    otherLinkAddNoFollow();
  },0);
  // 所有出站链接都需要添加 rel=nofollow 属性 end
  

});